import './app.css';



/* is production */
const isProd = process.env.NODE_ENV === 'production';



/* meta */
const meta = require('./js/meta.json');

/* data [UNCOMMENT THE LINE BELOW TO USE TEXTS FROM DATA IN JS] */
// const data = require('./js/data.json');



/* analytics */
/* SEND EVENT: analyticsEvent('Button', 'click', {eventLabel: 'Play'}); */
const analytics = require('universal-ga');

analytics.initialize(meta.trackingID);
analytics.pageview('/index');

if (meta.clientTrackingID.length > 0) {
    analytics.create(meta.clientTrackingID, 'clientTracker');
    analytics.name('clientTracker').pageview('/index');
}

const analyticsEvent = (category, action, options) => {
    analytics.event(category, action, options);

    if (meta.clientTrackingID.length > 0) {
        analytics.name('clientTracker').event(category, action, options);
    }
};

/* EXAMPLE */
/* analyticsEvent('Page', 'load', {eventLabel: 'Successfully'}); */



/* fonts */
const WebFont = require('webfontloader');

WebFont.load({
    custom: {
        families: ['Corsica Rambler LX:n3,n4,n5'],
        urls: ['./css/fonts.css']
    },
    typekit: {
        id: 'ejw5ayt'
    }
});



/* share */
import * as VanillaSharing from 'vanilla-sharing';

const shareButtons = [...document.querySelectorAll('.share__item')];

if (shareButtons.length > 0) {

    const shareOptions = {
        url: meta.url,
        title: meta.title,
        description: meta.description,
        image: meta.image,
        isVkParse: false,
        fbAppId: meta.fbappid
    };

    if (navigator.share !== undefined) {
        document.querySelector('.share__item--all').classList.add('share__item--show');
    }

    shareButtons.forEach(button => {
        button.addEventListener('click', () => {
            if (button.dataset.social === 'all' && navigator.share !== undefined) {
                navigator.share({
                    title: shareOptions.title,
                    url: shareOptions.url
                });
            } else {
                VanillaSharing[button.dataset.social](shareOptions);
            }

            analyticsEvent('Share', 'click', {eventLabel: 'Social: ' + button.dataset.social});
        });
    });

}



/* service worker */
if ('serviceWorker' in navigator && isProd) {
    window.addEventListener('load', () => {
        navigator.serviceWorker.register('./sw.js');
    });
}



/* gifts */
import Swiper from 'swiper/dist/js/swiper.min.js';

const gifts = [...document.querySelectorAll('.gift[data-items]')];

/*
    @example
    const currentDate = new Date(2018, 0, 1);
*/
const currentDate = new Date();

let throttle = false;

gifts.forEach(gift => {

    let giftDate = new Date(2017, 11, gift.dataset.id);

    if (currentDate >= giftDate) {

        gift.setAttribute('data-available', 'true');

        gift.addEventListener('click', () => {
            gift.setAttribute('data-open', 'true');

            new Swiper(gift.querySelector('.swiper-container'), {
                slidesPerView: 1,
                centeredSlides: true,
                pagination: {
                    el: '.swiper-pagination'
                },
                autoplay: {
                    delay: 2000,
                    disableOnInteraction: false
                }
            });

            analyticsEvent('Gift', 'click', {eventLabel: 'Open Day: ' + gift.dataset.id});
        });

    }

     gift.addEventListener('click', (evt) => {
        if (!throttle && evt.detail === 3) {
            gift.setAttribute('data-open', 'true');

            new Swiper(gift.querySelector('.swiper-container'), {
                slidesPerView: 1,
                centeredSlides: true,
                pagination: {
                    el: '.swiper-pagination'
                },
                autoplay: {
                    delay: 1000,
                    disableOnInteraction: false
                }
            });

            throttle = true;

            setTimeout(function () {
                gift.removeAttribute('data-open');
                throttle = false;
            }, 3000);
        }
    });

});



/* links */
const giftsLinks = [...document.querySelectorAll('.item__link')];

giftsLinks.forEach(link => {
    link.addEventListener('click', () => {
        analyticsEvent('Link', 'click', {eventLabel: 'Link Text: ' + link.textContent});
    });
});



/* chaos */

document.querySelector('.header__title').addEventListener('click', (evt) => {
    if (!throttle && evt.detail === 3) {
        document.querySelector('body').setAttribute('data-chaos', 'true');

        throttle = true;

        setTimeout(function () {
            document.querySelector('body').removeAttribute('data-chaos');
            throttle = false;
        }, 10000);
    }
});


// WEBPACK FOOTER //
// ./app.js